import {TranslatorValues, TranslatorFunction, OptionsMap} from 'js/tool/page/types';

const values: TranslatorValues = {
	options: {},
};

/**
 * If updating/refactoring anything related to translations funcionality, 
 * please also update the docs at: https://alephrnd.atlassian.net/wiki/spaces/TECHD/pages/335020166/Internationalization
 */
function setTranslator(value: TranslatorFunction) {
	if (location.search.includes('sf_culturex=xl')) { // AP-17915
		__ = (key) => key;

		return;
	}

	__ = value;
}

function setNetwork(value: string) {
	network = value;
}

function setOptions(value: OptionsMap, ns?: string) {
	if (value) {
		options = value;
	}

	if (ns) {
		values.options[ns + '_' + 'options'] = value;
	} else {
		values.options.options = value;
	}
}

export const setCurrent = {
	translator: setTranslator,
	network:    setNetwork,
	options:    setOptions,
};

export let options: any = {};

export let network = '';

export let __ : (...input: any) => any | TranslatorFunction = (...input) => input[0];
